<template>
  <div class="container">
    <topnav class="container-header"></topnav>
    <router-view class="container-content" v-if="routerAlive"></router-view>
    <footernav class="container-footer"></footernav>
    <fixed-right></fixed-right>
  </div>
</template>
<script>
import topnav from "../components/topnav.vue";
import footernav from "../components/footernav.vue";
import FixedRight from "../components/fixedRight";

export default {
  name: "index",
  data() {
    return {
      routerAlive: true,
      bodyflag: true,
      b_modal: false,
      showclass: "asideshow",
      showtype: false,
      loading: false,
      centerDialogVisible: false,
    };
  },
  computed: {
    userInfo() {
      return this.$store.state.userInfo
    }
  },
  provide() {    //在父组件中创建属性
    return {
      routerRefresh: this.routerRefresh
    }
  },
  // 注册组件
  components: {
    footernav,
    topnav,
    FixedRight
  },
  created() {
    this.$store.dispatch('getCartList');
  },
  methods: {
    routerRefresh() {
      this.routerAlive = false;
      this.$nextTick(() => {
        this.routerAlive = true;
      })
    }
  }
};
</script>
<style lang="less" scoped>
.container-content {
  min-height: calc(100vh - 199px - 187px);
}

.dialogIMBox /deep/ .el-dialog--center .el-dialog__body {
  text-align: initial;
  padding: 9px 0px 0px;
  height: 445px;
}

.dialogIMBox /deep/ .el-dialog--center {
  text-align: center;
  position: absolute;
  right: 50px;
  bottom: 0px;
}

div#content-main-1 {
  height: inherit;
}

.asideshow {
  width: 240px !important;
  height: 100%;
  background-color: #334157;
  margin: 0px;
}

</style>



// WEBPACK FOOTER //
// src/views/index.vue